<template>
  <div class="nav" :class="isTransparent ? 'transparent' : 'no-transparent'">
    <div class="logo" @click="$router.push({ path:'/' })">
      <img src="~@/assets/logo.png" />
    </div>
    <div>
      <router-link to="/">首页</router-link>
      <router-link to="/pc-project">项目历程</router-link>
      <router-link to="/pc-product">产品介绍</router-link>
      <router-link to="/pc-honor">荣誉资质</router-link>
      <router-link to="/pc-about">关于我们</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pc-header',
  props: {
    // 是否透明
    isTransparent : { type: Boolean, default: false }
  }
}
</script>
<style scoped lang="stylus">
.transparent {
  background: rgba(0, 0, 0, 0.9)!important;
}

.no-transparent {
  background: rgba(0, 0, 0, 0.5)!important;
}

.nav {
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 9;
  position: sticky;
  top: 0px;

  a {
    padding-right: 74px;
  }

  .logo {
    width: 169px;
    height: 47px;
    display: flex;
    align-items: center;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  a {
    color: #B3B3B3;
    text-decoration: none;
    padding-left: 74px;
    font-size: 20px;

    &.router-link-exact-active {
      color: #FFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pcHeader.vue